common.View.create('website::layouts.Main', {

    onDOMLoad()
    {
        this.initNavbar();
        this.initScrollButton();
    },

    initNavbar()
    {
        // Give parent .active when has a .active subitem
        $('.navbar-nav .dropdown-menu > .dropdown-item.active').each(function(){
            $(this).parents('.nav-item').find('.nav-link').addClass('active');
        });
    },

    initScrollButton()
    {
        $(window).scroll(() => {
            // Show scroll button?
            if ($(window).scrollTop() > 500) {
                this.element.find('.scroll-button').fadeIn('fast');
            } else {
                this.element.find('.scroll-button').fadeOut('fast');
            }
        });

        if($('.website\\:\\:layouts-main-Header').length) {
            this.element.find('.scroll-button').click((e) => {

                // Scroll to top with animation
                $('html, body').animate({
                    scrollTop: $('.website\\:\\:layouts-main-Header').offset().top - 100
                }, 500);

                e.preventDefault();
            });
        }
    },
});
